import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Flex, FormControl, FormLabel, Image, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import { Icons } from "../../Assets/icons"; 
import { Images } from "../../Assets/images";
import Loader from "../../Components/Loader/Loader";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { AuthAPI } from "../../Apis/authAPI";
import { errorHandler } from "../../Utils/handler";

const AdminForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { success, error } = useToastWrapper();

  const handleSubmit = async () => {
    if (!email) return error("Please enter email", "");
    try {
      setLoading(true);
      const res = await AuthAPI.postForgetPassword({ email});
      if (res) {
        success("Reset link sent to your email", "");
        setEmail("");
      }
    } catch (err) {
      error(errorHandler(err), "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex w="100vw" h="100dvh" justifyContent="center" alignItems="center">
      <Box width="400px" shadow="md" p={10}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Image src={Images.AftrLogo} w="160px" objectFit="contain" alt="AFTR" />
          <Text fontSize="2xl" fontWeight="bold" mt={4}>
            Admin Password Recovery
          </Text>
        </Box>
        
        <Box mt={8}>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <InputGroup>
              <InputLeftElement h="50px">
                <Image src={Icons.LoginMail} alt="Email" />
              </InputLeftElement>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                h="50px"
                type="email"
                placeholder="Enter admin email"
              />
            </InputGroup>
          </FormControl>
          
          <Button
            onClick={handleSubmit}
            mt={8}
            width="full"
            h="60px"
            isLoading={loading}
            colorScheme="blue"
          >
            Send Reset Link
          </Button>
          
          <Text mt={4} textAlign="center">
            <span 
              onClick={() => navigate("/admin/login")} 
              style={{ cursor: "pointer", color: "blue" }}
            >
              Back to Login
            </span>
          </Text>
        </Box>
      </Box>
    </Flex>
  );
};

export default AdminForgotPassword;